import { render, staticRenderFns } from "./consumptionCarousel.vue?vue&type=template&id=b82a1be2&scoped=true&"
import script from "./consumptionCarousel.vue?vue&type=script&lang=js&"
export * from "./consumptionCarousel.vue?vue&type=script&lang=js&"
import style0 from "./consumptionCarousel.vue?vue&type=style&index=0&id=b82a1be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82a1be2",
  null
  
)

export default component.exports